module.exports = __webpack_public_path__ + "static/media/gravure0.01eb3ddc.jpg";